import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import { FdkIconComponent } from '../icon/icon.component';
import { FdkInitialsComponent } from '../initials/initials.component';

export type FdkCardVariant = 'select' | 'more' | 'add' | 'signIn' | 'readOnly';

@Component({
  selector: 'fdk-card',
  imports: [FdkIconComponent, FdkInitialsComponent],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkCardComponent {
  @Input({ required: true }) title!: string;
  @Input() description = '';
  @Input() highlights: readonly string[] = [];
  @Input() location: readonly string[] = [];
  @Input() initials: string = '';
  @Input() variant: FdkCardVariant = 'select';
  @Input({ transform: booleanAttribute }) selected = false;

  protected logoLoadFailed = false;
  private logoUrl = '';

  @Input()
  set logo(value: string) {
    this.logoUrl = value;
    this.logoLoadFailed = false;
  }

  get logo(): string {
    return this.logoUrl;
  }

  protected handleLogoError(): void {
    this.logoLoadFailed = true;
  }
}
